<template>
  <div
    class="flex flex-col items-center justify-between text-[#1c3b3b]"
    :data-prerender-ready="prerenderReady ? 'true' : 'false'"
  >
    <!-- banner -->
    <div :class="['relative flex flex-col h-[900px] w-full text-center', {'summer-section': summerActive}]">
      
      <div :class="['summer-content relative flex flex-col justify-evenly items-left self-center w-full max-w-[1200px] px-[20px]', partnerAdVisible ? 'summer-content--with-ad pt-[220px]' : 'pt-[300px]']">
        <h1 :class="['font-serif font-bold text-[3rem] text-left', summerActive ? 'text-[#173B3A]' : 'text-white']" style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"> {{ $t("home.slogan.slogan_1") }} <span :class="summerActive ? 'text-[#FF8A3D]' : 'text-red-500'">{{ $t("home.slogan.slogan_2") }}</span><br></h1>
      
        <p :class="['text-sm my-6 text-left', summerActive ? 'text-[#5F7472]' : 'text-white text-stone-800']">{{ $t("home.slogan.foot") }}</p>

        <div v-if="summerActive" class="summer-hero-promo mb-[28px]">
          <div class="summer-hero-promo__main">
            <span class="summer-hero-promo__tag">{{ promotionBadge }}</span>
            <div class="summer-hero-promo__copy">
              <strong>{{ promotionTitle }}</strong>
              <span>{{ promotionSubtitle }}</span>
            </div>
          </div>
        </div>

        <div class="flex justify-between">
          <router-link v-if="!isLogin" to="/signup" @click.native="trackHomePrimaryCta('signup')">
            <div :class="['inline-flex justify-center items-center space-x-3 w-80 h-12 rounded-xl hover:ring-offset-2 hover:ring-1 hover:cursor-pointer', summerActive ? 'summer-button' : 'border border-blue-500 text-blue-500']">
              <span class="font-bold font-sans text-sm">{{ $t("home.action.register") }}</span>
              <svg width="19" height="14" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block animate-go">
                <path d="M0.0902161 9.58947L16.7281 9.58947" stroke="currentColor" stroke-width="2"/>
                <path d="M8.5 1L16.9998 9.49981L8.5 17.9996" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
          </router-link>
          <div v-else @click="clickHeroBuy" :class="['inline-flex justify-center items-center space-x-3 w-80 h-12 rounded-xl hover:ring-offset-2 hover:ring-1 hover:cursor-pointer', summerActive ? 'summer-button' : 'border border-blue-500 text-blue-500']">
            <span class="font-bold font-sans text-sm">{{ $t("home.action.checkout") }}</span>
            <svg width="19" height="14" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block animate-go">
              <path d="M0.0902161 9.58947L16.7281 9.58947" stroke="currentColor" stroke-width="2"/>
              <path d="M8.5 1L16.9998 9.49981L8.5 17.9996" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
        </div>

        <PartnerAdBanner :config="partnerAdConfig" compact></PartnerAdBanner>
      </div>

      <div class="absolute top-[0%] right-[0%] bottom-[0%] left-[0%] w-full h-full z-[-1]">
        <div class="flex flex-row justify-center items-stretch w-full h-full overflow-hidden">
          <div v-if="summerActive" class="summer-hero-web-bg">
            <div class="summer-sun"></div>
            <div class="summer-leaf summer-leaf-a"></div>
            <div class="summer-leaf summer-leaf-b"></div>
            <div class="summer-wave summer-wave-a"></div>
            <div class="summer-wave summer-wave-b"></div>
          </div>
          <video v-else ref="bannerVideo" @click="toggleVideo" @ended="handleVideoEnded" muted autoplay loop  playsinline 
          poster="@/assets/index/img/index/poster_default.jpeg"
          class="aspect-video w-full h-full object-fill cursor-pointer">
            <source src="@/assets/index/img/index/default.mp4" type="video/mp4">
            Your browser does not support
          </video>

          <div :class="['absolute bottom-0 left-0 right-0 h-[152px] flex justify-evenly items-center self-center bg-gradient-to-b from-sky-50/[0] text-left text-sm', summerActive ? 'to-white/55 text-[#173B3A]' : 'to-sky-100/[0.35] text-white']">
            <div class="leading-8 max-w-[200px]">
              <div>{{ $t("home.advantages.adv_1") }}</div>
            </div>
            <div class="leading-8 max-w-[200px]">
              <div>{{ $t("home.advantages.adv_2") }}</div>
            </div>
            <div class="leading-8 max-w-[200px]">
              <div>{{ $t("home.advantages.adv_3") }}</div>
            </div>
            <div class="leading-8 max-w-[200px]">
              <div>{{ $t("home.advantages.adv_4") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Features-->
    <div class="flex flex-col w-full pb-28 text-center bg-[#f0f2f8]">
      <div class="flex flex-col items-center w-full max-w-[1200px] mx-auto pt-20 ">
        <h2 class="text-5xl font-bold mb-2">{{ $t("home.features.title") }}</h2>
        <p class="max-w-[540px] mb-20 text-sm">
          {{ $t("home.features.intro") }}
        </p>
        
        <div class="w-full flex flex-row justify-between items-center"
            style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;">
            
          <div class="">
            <div class="flex fade-in">
              <div class="flex flex-col w-[22rem] h-[22rem] pt-[5.25rem] pb-[5rem] pl-[1rem] rounded-full border-[1px] border-[#bbc4c4] text-center">
                <div class="-tracking-[.15rem] font-['Manrope,sans-serif'] text-[6.5rem] font-extralight leading-[1.1] inline-block">{{ $t("home.features.metrics.available.badage") }}</div>
                <div class="font-['Manrope,sans-serif'] text-[1.5rem] font-medium leading-[1.6] inline-block">{{ $t("home.features.metrics.available.text") }}</div>
              </div>
              <div class="flex flex-col w-[22rem] h-[22rem] pt-[5.25rem] pb-[5rem] pl-[1rem] -translate-x-[1.75rem] rounded-full border-[1px] border-[#bbc4c4] text-center">
                <div class="-tracking-[.15rem] font-['Manrope,sans-serif'] text-[6.5rem] font-extralight leading-[1.1] inline-block">{{ $t("home.features.metrics.coverage.badage") }}</div>
                <div class="font-['Manrope,sans-serif'] text-[1.5rem] font-medium leading-[1.6] inline-block">{{ $t("home.features.metrics.coverage.text") }}</div>
              </div>
            </div>
            <div class="flex -translate-y-[1.75rem]">
              <div class="flex flex-col w-[22rem] h-[22rem] pt-[5.25rem] pb-[5rem] pl-[1rem] rounded-full border-[1px] border-[#bbc4c4] text-center">
                <div class="-tracking-[.15rem] font-['Manrope,sans-serif'] text-[6.5rem] font-extralight leading-[1.1] inline-block">{{ $t("home.features.metrics.speed.badage") }}</div>
                <div class="font-['Manrope,sans-serif'] text-[1.5rem] font-medium leading-[1.6] inline-block">{{ $t("home.features.metrics.speed.text") }}</div>
              </div>
              <div class="flex flex-col w-[22rem] h-[22rem] pt-[5.25rem] pb-[5rem] pl-[1rem] -translate-x-[1.75rem] rounded-full border-[1px] border-[#bbc4c4] text-center">
                <div class="-tracking-[.15rem] font-['Manrope,sans-serif'] text-[6.5rem] font-extralight leading-[1.1] inline-block">{{ $t("home.features.metrics.latency.badage") }}</div>
                <div class="font-['Manrope,sans-serif'] text-[1.5rem] font-medium leading-[1.6] inline-block">{{ $t("home.features.metrics.latency.text") }}</div>
              </div>
            </div>
          </div>

          <div class="pl-[2.5rem] fade-in">
            <div class="flex flex-col justify-center items-start">
              <div class="max-w-[520px] text-left pb-[20px]">
                <h3 class="mb-3 font-['Manrope,sans-serif'] text-[2.5rem] leading-[1.2]">{{ $t("home.features.f1.caption") }}</h3>
                <p class="mb-6 white-space-pre-wrap font-[1.375rem] leading-[1.6]">{{ $t("home.features.f1.comments") }}</p>
              </div>
              <div class="max-w-[520px] text-left pb-[20px]">
                <h3 class="mb-3 font-['Manrope,sans-serif'] text-[2.5rem] leading-[1.2]">{{ $t("home.features.f2.caption") }}</h3>
                <p class="max-w-[415px] mb-6 font-[1.375rem]">{{ $t("home.features.f2.comments") }}</p>
              </div>
              <div class="max-w-[520px] text-left pb-[20px]">
                <h3 class="mb-3 font-['Manrope,sans-serif'] text-[2.5rem] leading-[1.2]">{{ $t("home.features.f3.caption") }}</h3>
                <p class="max-w-[415px] mb-6 font-[1.375rem]">{{ $t("home.features.f3.comments") }}</p>
              </div>
              <button @click="clickBuy" class="fade-in px-11 py-4 rounded-[4rem] border border-[#1c3b3b] text-white bg-[#1c3b3b] hover:text-inherit hover:bg-transparent hover:transition-transform cursor-pointer">{{ $t("home.features.checkout") }}</button>
            </div>
          </div>
        </div>
          
      </div>
    </div>

  
    <SolutionsView @clickBuy="clickBuy" @clickCustomService="clickCustomService"></SolutionsView>

    <ScenesView class="fade-in bg-[#f0f2f8]"></ScenesView>

    <!--Coverage-->
    <div class="flex flex-col w-full pb-28 text-center">
      <div class="flex flex-col items-center w-full max-w-[1200px] mx-auto pt-20 border border-transparent">
        <h2 class="leading-[52px] mb-[18px] text-[40px] text-center">{{ $t("home.coverage.title") }}</h2>
        <p class="max-w-[540px] mb-[55px] text-[18px] leading-[24px] text-center">{{ $t("home.coverage.intro") }}</p>
    
        <section class="fade-in py-[34px] px-[41px] m-auto mb-[84px]">
          <img class="w-full object-contain rounded-full" alt="" style="" src="@/assets/index/img/index/world.svg">
        </section>

        <section class="fade-in flex flex-wrap justify-between w-full m-auto">
          <div v-for="region in regions" :key="region.area" class="flex justify-start item-center mb-[63px] w-1/4 min-w-[210px]">
            <img :src="getImg('img_'+region.area.toLocaleLowerCase()+'.png')" alt="" width="52px" height="52px">
            <div class="flex flex-col justify-between text-left ml-6">
              <p class="text-[18px] leading-[27px] font-bold">{{region.name}}</p>
              <p class="text-[16px] leading-[25px]">{{region.stocks}} IPs</p>
            </div>
          </div>
        </section>

        <button @click="clickBuy" class="fade-in px-11 py-4 rounded-[4rem] border border-[#1c3b3b] text-white bg-[#1c3b3b] hover:text-inherit hover:bg-transparent hover:transition-transform cursor-pointer">{{ $t("home.coverage.checkout") }}</button>
      </div>
    </div>

    <!--problems-->
    <div class="flex flex-col w-full pb-28 text-center">
      <div class="flex flex-col items-center w-full max-w-[1200px] mx-auto pt-20 border border-transparent">
        <h2 class="leading-[52px] mb-[18px] text-[40px] text-center">{{ $t("home.problems.title") }}</h2>        
        <p class="mb-[45px] text-[18px] leading-[24px] text-center">{{ $t("home.problems.intro") }}</p>
      
        <section class="fade-in w-full">
          
          <div v-for="(qa,index) in problems" :key="index" :class="{'pb-[43px] bg-white': activeProblemIndex === index}" @click="activeProblemIndex = index" 
            class="flex flex-col items-start justify-center m-auto mb-[25px] px-[25px] text-left bg-white/70 border-t-[#bbc4c4] border-t border-solid">
            <div class="flex justify-between items-center w-full cursor-pointer min-h-[87px]" :class="{'pt-[32px] pr-0 pb-0 pl-0': activeProblemIndex === index}">
              <span class="text-[16px] leading-[25px]" :class="{'text-[#ec4899]': activeProblemIndex === index}">{{qa.question}}</span>
              <div class="img">
                <i :class="['el-icon-plus transition-all duration-300', {'rotate-45': activeProblemIndex === index}]" alt="" width="16px" height="2px"></i>
              </div>
            </div>
            <div :class="{'hidden': activeProblemIndex !== index}" class="text-[16px] leading-[1.6em] text-slate-600">
              {{qa.answer}}
            </div>
          </div>
          <el-divider class="bg-[#bbc4c4]"></el-divider>
      
          <el-link :underline="false" 
            class="fade-in  px-11 py-4 rounded-[4rem] border border-[#1c3b3b] !text-white bg-[#1c3b3b] hover:!text-[#1c3b3b] hover:bg-transparent hover:transition-transform cursor-pointer mt-[40px] !py-[17px] !px-[60px]" 
            href="/faq/" target="_blank">{{ $t("home.problems.action") }}</el-link>

        </section>
      </div>
    </div>


    <!--Parters Links-->
    <div class="flex flex-col w-full pb-28 text-center">
      <div class="flex flex-col items-center w-full max-w-[1200px] mx-auto pt-20 border border-transparent">
        <h2 class="leading-[52px] mb-[18px] text-[40px] text-center">{{ $t("home.parters.title") }}</h2>        
        <p class="mb-[45px] text-[18px] leading-[24px] text-center">{{ $t("home.parters.intro") }}</p>

        <div
          data-partner-links-host
          :class="['partner-links-static-host', `partner-links-locale--${partnerLinksLocale}`]"
        >
          <div v-if="partnerLinksHtml" v-html="partnerLinksHtml"></div>
          <div v-else :class="['partner-marquee fade-in', {'partner-marquee--static': !partnerMarqueeEnabled}]">
            <div class="partner-track" :style="partnerTrackStyle">
              <a v-for="(partner, index) in partnerDisplayLinks" :key="`${partner.id}-${index}`" :href="partner.url" target="_blank" :rel="partner.rel"
                class="partner-card">
                <img :src="partner.icon" :alt="partner.alt" class="partner-card__logo">
                <p class="partner-card__name partner-locale partner-locale--en" lang="en">{{ partner.name.en }}</p>
                <p class="partner-card__name partner-locale partner-locale--zh-cn" lang="zh-CN">{{ partner.name['zh-cn'] }}</p>
                <p v-if="partner.description.en" class="partner-card__desc partner-locale partner-locale--en" lang="en">{{ partner.description.en }}</p>
                <p v-if="partner.description['zh-cn']" class="partner-card__desc partner-locale partner-locale--zh-cn" lang="zh-CN">{{ partner.description['zh-cn'] }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- talk -->
    <div ref="talkView" class="flex flex-col justify-between items-center max-w-[1200px] w-full mx-auto min-h-[422px] bg-cover bg-[#e9ecec] pt-[93px] text-center relative rounded-t-[4rem]">
      <h2 class="text-[40px] leading-[24px] mb-[36px]">{{ $t("home.contact_sales.title") }}</h2>
      <p class="fade-in text-[24px] leading-[35px] max-w-[820px] mx-auto mb-[52px]">{{ $t("home.contact_sales.instructions.i1") }}<br> {{ $t("home.contact_sales.instructions.i2") }}</p>
      
      <div @click="clickCustomService" 
        style="background: linear-gradient(138deg, #2e6062, #69a971);"
        class="fade-in flex justify-center items-center border-box mb-[30px] w-20 h-20 rounded-full hover:cursor-pointer transition-all duration-500 hover:scale-105 group">
        <i class="el-icon-microphone transition-all duration-300 group-hover:scale-[2] text-white" style="font-size: 28px;"></i>
      </div>
    </div>
  </div>

</template>

<script>
import SolutionsView from "@/components/solutions-view.vue"
import ScenesView from "@/components/scenes-view.vue"
import PartnerAdBanner from "@/components/partner-ad-banner.vue"
import { isPromotionEnabled, promotionConfig, promotionText } from '@/config/site-theme'
import { getCapturedPartnerLinksHtml, getFallbackPartnerLinks } from '@/config/partner-links'
import { loadPartnerAdConfig } from '@/config/partner-ad'
import { trackAnalyticsEvent } from '@/util/analytics'

export default {
  name: 'home',
  components: { SolutionsView, ScenesView, PartnerAdBanner },
  data() {
    return {
      isPlaying: true,
      hasIntersected: false,

      activeProblemIndex: 0,
      partnerLinks: getFallbackPartnerLinks(),
      partnerLinksHtml: getCapturedPartnerLinksHtml(),
      partnerAdConfig: null,
      prerenderReady: false,
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin
    },
    regions() {
      return this.$t("home.coverage.regions")
    },
    problems() {
      return this.$t("home.problems.items")
    },
    summerActive() {
      return isPromotionEnabled();
    },
    promotionTargetUrl() {
      return promotionConfig.targetUrl;
    },
    promotionBadge() {
      return promotionText(this, 'badge');
    },
    promotionTitle() {
      return promotionText(this, 'title');
    },
    promotionSubtitle() {
      return promotionText(this, 'subtitle');
    },
    partnerAdVisible() {
      if (!this.partnerAdConfig || !this.partnerAdConfig.enabled) {
        return false;
      }
      const locale = String(this.$i18n.locale || '').toLowerCase();
      return this.partnerAdConfig.locales.includes(locale);
    },
    partnerMarqueeEnabled() {
      return this.partnerLinks.length >= 4;
    },
    partnerLinksLocale() {
      return String(this.$i18n.locale || '').toLowerCase() === 'zh-cn' ? 'zh-cn' : 'en';
    },
    partnerDisplayLinks() {
      return this.partnerMarqueeEnabled ? [...this.partnerLinks, ...this.partnerLinks] : this.partnerLinks;
    },
    partnerTrackStyle() {
      if (!this.partnerMarqueeEnabled) {
        return {};
      }
      const duration = Math.max(28, this.partnerLinks.length * 6);
      return {
        animationDuration: `${duration}s`,
      };
    }
  },
  activated() {
    const hash = this.$route.hash;
    if (hash) {
      const targetElement = document.getElementById(hash.substring(1));
      if (targetElement) {
        targetElement.scrollIntoView();
      }
    }
  },
  async mounted() {
    this.initIntersectionObserver();
    this.initFadeInIntersectionObserver();
    if (!this.partnerLinksHtml) {
      try {
        const response = await fetch('/config/partner-links.html', { cache: 'no-store' });
        if (response.ok) {
          const html = await response.text();
          if (html.includes('data-partner-links-version=') || html.includes('data-partner-links-empty=')) {
            this.partnerLinksHtml = html;
          }
        }
      } catch (_) { /* Retain the bundled fallback if publication is unavailable. */ }
    }
    await this.loadPartnerAd();
    await this.$nextTick();
    this.prerenderReady = true;
  },
  methods: {
    clickHeroBuy() {
      this.trackHomePrimaryCta('residential');
      this.clickBuy('residential');
    },
    trackHomePrimaryCta(cta) {
      trackAnalyticsEvent('home_primary_cta_click', {
        cta,
        locale: this.$i18n.locale,
        placement: 'home_hero',
      });
    },
    clickBuy(type) {
      if (type === 'residential') {
        this.$router.push({path: '/residential/'})
      } else {
        this.$router.push({path: '/staticisp/'})
      }
    },
    clickCustomService() {
      window.dispatchEvent(new CustomEvent('open-wechat-qr'));
    },
    getImg(img) {
      return require(`@/assets/index/img/index/${img}`);
    },
    async loadPartnerAd() {
      this.partnerAdConfig = await loadPartnerAdConfig();
    },
    initIntersectionObserver() {
      const target = this.$refs.talkView;
      const options = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.1, // 元素有 10% 可见
      };

      const callback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasIntersected) {
            this.hasIntersected = true;
            this.handleIntersection();
            observer.unobserve(entry.target); // 停止观察
          }
        });
      };

      const observer = new IntersectionObserver(callback, options);
      observer.observe(target);
    },
    handleIntersection() {
    },
    toggleVideo() {
      const video = this.$refs.bannerVideo;
      if (!video) {
        return;
      }
      video.loop = true;  // 确保视频循环

      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },
    handleVideoEnded() {
      const video = this.$refs.bannerVideo;
      if (!video) {
        return;
      }
      video.currentTime = 0;
      this.isPlaying = false;
    },
    async initFadeInIntersectionObserver() {
      const options = {
          threshold: 0.1
      };
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target;
            element.classList.add('fade-in-end');

            observer.unobserve(entry.target);
          }
        });
      }, options);

      this.$nextTick(() => {
        const elements = this.$el.querySelectorAll('.fade-in')
        elements.forEach(element => {
          observer.observe(element);
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>

::v-deep .el-tabs__header {
  margin-bottom: 0px;
}


::v-deep .el-tabs__nav-scroll {
  display: flex;
  justify-content: space-around;
}

::v-deep .el-tabs__nav {
  margin-bottom: 26px;
}

.summer-hero-web-bg {
  position: relative;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(circle at 74% 23%, rgba(247, 201, 72, 0.34), transparent 14%),
    radial-gradient(circle at 18% 78%, rgba(18, 110, 106, 0.12), transparent 22%),
    linear-gradient(145deg, #f4fbf8 0%, #e3f5ef 48%, #dff2fb 100%);
}

.summer-hero-promo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(680px, 100%);
  gap: 18px;
  padding: 12px 14px 12px 12px;
  border: 1px solid rgba(255, 138, 61, 0.28);
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.88), rgba(255, 244, 223, 0.86));
  box-shadow: 0 18px 44px rgba(18, 110, 106, 0.12);
  backdrop-filter: blur(12px);
}

.summer-hero-promo__main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.summer-hero-promo__tag {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 86px;
  height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  color: #fff;
  font-weight: 700;
  background: #ff8a3d;
  box-shadow: 0 10px 20px rgba(255, 138, 61, 0.24);
}

.summer-hero-promo__copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  text-align: left;
  color: #173b3a;
}

.summer-hero-promo__copy strong {
  font-size: 16px;
  line-height: 22px;
}

.summer-hero-promo__copy span {
  color: #5f7472;
  font-size: 12px;
  line-height: 18px;
}

.summer-hero-promo__action {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  color: #126e6a;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid rgba(18, 110, 106, 0.24);
  background: rgba(255, 255, 255, 0.78);
  text-decoration: none;
}

.summer-sun {
  position: absolute;
  top: 118px;
  right: 12%;
  width: 142px;
  height: 142px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(247, 201, 72, 0.75), rgba(247, 201, 72, 0.12) 62%, transparent 70%);
}

.summer-leaf {
  position: absolute;
  border: 1px solid rgba(18, 110, 106, 0.18);
  background: rgba(255, 255, 255, 0.36);
  transform: rotate(-18deg);
}

.summer-leaf-a {
  right: 18%;
  bottom: 178px;
  width: 260px;
  height: 92px;
  border-radius: 100% 0 100% 0;
}

.summer-leaf-b {
  right: 5%;
  top: 332px;
  width: 160px;
  height: 56px;
  border-radius: 100% 0 100% 0;
  transform: rotate(24deg);
}

.summer-wave {
  position: absolute;
  left: 0;
  width: 120%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(18, 110, 106, 0.2), transparent);
}

.summer-wave-a {
  top: 44%;
  transform: rotate(-7deg);
}

.summer-wave-b {
  top: 58%;
  transform: rotate(5deg);
}

@media (max-width: 640px) {
  .summer-content {
    padding-top: 220px;
  }

  .summer-content--with-ad {
    padding-top: 110px;
  }

  .summer-hero-promo {
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }

  .summer-hero-promo__main {
    align-items: flex-start;
  }

  .summer-hero-promo__action {
    width: 100%;
  }

  .summer-content p:first-of-type {
    font-size: 2.1rem;
    line-height: 1.18;
  }

  .summer-leaf-a,
  .summer-leaf-b {
    opacity: 0.45;
  }

}

</style>
